import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  viewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Modal } from 'flowbite';
import { InputType, UserType } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';
import { APP } from 'src/app/config/app';

@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styleUrls: ['./modal-change-password.component.scss'],
  standalone: false,
})
export class ModalChangePasswordComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() password: string = '';
  @Input() confirmPassword: string = '';
  @Input() loading: boolean = false;
  @Input() userType?: UserType = UserType.Regular;
  @Input() errors: any[] = [];
  @Output() action = new EventEmitter<any>();
  readonly modalContainer = viewChild.required<ElementRef<HTMLElement>>('modalContainer');

  private readonly PASSWORD_MIN_LENGTH = APP.PASSWORD_MIN_LENGTH;

  public InputType = InputType;
  public UserType = UserType;
  public images = images;

  public buttonDisabled = false;

  public changePasswordFormControl: FormGroup;
  public invalid: any[] = [];
  public hasErrors: boolean = false;

  constructor(public literalService: LiteralService) {}

  emitEvent() {
    this.action.emit(this.password);
    this.password = '';
    this.confirmPassword = '';
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  getError(input: string) {
    if (this.errors.includes('match')) {
      return this.literalService.get('errors.match', true);
    } else if (this.errors.includes('minlength')) {
      return this.literalService.get('errors.minlength', true, { length: 8 });
    } else if (this.errors.includes('required')) {
      return this.literalService.get('errors.requiredField', true);
    } else if (this.errors.includes('weakPasswordError')) {
      return this.literalService.get('errors.mismatch', true);
    } else if (this.errors.includes('passwordRepeatedError')) {
      return this.literalService.get('errors.sameAsOld', true);
    }
    return this.literalService.get('errors.incorrectField', true);
  }

  setPassword(event: any) {
    event.id === 'password' ? (this.password = event.value) : null;
    event.id === 'confirmPassword'
      ? (this.confirmPassword = event.value)
      : null;
  }

  close() {
    this.password = '';
    this.confirmPassword = '';
    this.modal.hide();
  }

  public checkPasswordLength(): void {
    this.buttonDisabled =
      this.password.length < this.PASSWORD_MIN_LENGTH ||
      this.confirmPassword.length < this.PASSWORD_MIN_LENGTH;
  }

  onSubmit() {
    if (this.password !== this.confirmPassword) {
      this.errors = ['match'];
      this.hasErrors = true;
      return;
    }
    this.emitEvent();
  }
}
